import { Injectable } from '@angular/core';
import {
    DwAction, DwActionHandler, DwActionResult, DwActionState, DwActionType, DwModalButtonStandardConfigs,
    DwModalConfig, DwModalService, DwModalSize
} from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { AdminManagerService } from '../../admin/services/admin-manager.service';
import { PostLoginRepositoryService } from '../../post-login/services/post-login-repository.service';
import { OnboardingRole, StudentOnboardingModalComponent } from '../components/student-onboarding-modal/student-onboarding-modal.component';

/**
 * Opens the onboarding walkthrough. Attach this action to a userMenu metadata
 * record so authenticated users can replay the tour from the user menu.
 */
@DwAction({
    keyName: 'onboarding-action',
    display: 'View Onboarding Tour',
    actionType: DwActionType.menuAction,
    isGlobal: true,
    defaultSecurityConfig: {
        requireAuthentication: true,
        useEmulatedPermissions: false,
    }
})
@Injectable()
export class StudentOnboardingActionService implements DwActionHandler {
    constructor(
        private dwModalService: DwModalService,
        private postLoginRepository: PostLoginRepositoryService,
        private adminManagerService: AdminManagerService
    ) {
    }

    handleAction(actionState: DwActionState<any>): Observable<DwActionResult> {
        return this.postLoginRepository.getExperience(true, true).pipe(
            mergeMap(experience => this.showOnboarding(experience.Onboarding?.Role || 'student'))
        );
    }

    showOnboarding(role: OnboardingRole = 'student'): Observable<DwActionResult> {
        const modalConfig = new DwModalConfig();
        const schoolName = this.adminManagerService.getAviatorUser()?.FlightSchoolName?.trim() || 'your school';

        modalConfig.data = { role, schoolName };

        // The component renders its own chrome (media header, dots, buttons),
        // so the framework footer is hidden here and the header via scoped CSS
        // in styles/features/student-onboarding-modal.scss.
        modalConfig.buttons = [DwModalButtonStandardConfigs.instance.okButton];
        modalConfig.hideFooter = true;

        modalConfig.allowFullScreen = false;
        modalConfig.modalSize = DwModalSize.responsive;

        modalConfig.component = StudentOnboardingModalComponent;
        modalConfig.title = `Welcome to ${schoolName}`;

        return this.dwModalService.showModal<any, any>(modalConfig)
            .pipe(map(modalResult => {
                const result = new DwActionResult();

                result.success = true;
                result.cancelled = modalResult.cancelled;

                return result;
            }));
    }
}
